import { render, staticRenderFns } from "./Production.vue?vue&type=template&id=0fe2fcb2&scoped=true&"
import script from "./Production.vue?vue&type=script&lang=js&"
export * from "./Production.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe2fcb2",
  null
  
)

export default component.exports